// import { LoginRes } from "@/types/dto/loginRes";
import { commonGetData, createExceptionRes, createResFromResponse, Res } from "./common";
import { getData, postData } from "./client_utils";
import { FetchSchoolsParam, SchoolsResource } from "../dto/SchoolsResource";
import { FetchSchoolCoursesParam, SchoolCoursesResource } from "../dto/SchoolCoursesResource";

import { CertificationsResponse, PostExecuteCertificationsDTO } from "@/generated/@habacus/certification_api/src/models";
import { CertificationsRequest } from "../dto/CertificationRequest";
import { AdvisoryCitiesRequest, AdvisoryCountriesRequest, CitiesResDTO, PostPromoterInviteRequest, PromoterSearchItemResource, SchoolCourseTypologiesRequest, SchoolCourseTypologySearchResDTO, SchoolPropaedeuticDegreeRequest, StudentCountriesResDTO } from "@/generated/@habacus/hcp_api/src";
import { CertificationReq, CertificationResp, Consent, MapsData, ResultsExtraDataResp } from "@/types/typesInterfaces";

const BASE_API = () => {
    try {
        return `${window.location.protocol}//${window.location.host}`;
    } catch (error) {
        return process.env.BASE_URL!;
    }
}

const API_GET_MAPS_REVIEW = () => `${BASE_API()}/api/google`;
const API_GET_CITIES = () => `${BASE_API()}/api/cities`;
const API_GET_COUNTRIES = () => `${BASE_API()}/api/countries`;

const API_GET_SCHOOLS = () => `${BASE_API()}/api/schools`;
const API_GET_SCHOOL_COURSES_TYPOLOGIES = () => `${BASE_API()}/api/school_course_typologies`;
const API_GET_SCHOOL_PROPAEDEUTIC_DEGREE = () => `${BASE_API()}/api/school_propaedeutic_degree`;

const API_GET_SCHOOL_COURSES = () => `${BASE_API()}/api/school_courses`;

const API_CREATE_CERTIFICATIONS = () => `${BASE_API()}/api/certifications`;
const API_CERTIFICATIONS_HEALTH_CHECK = () => `${BASE_API()}/api/certifications_health_check`;
const API_CERTIFICATIONS_SEARCH = () => `${BASE_API()}/api/pre-certifications`;
const API_COMPARE = () => `${BASE_API()}/api/compare`;
const API_COMPARE_INFO = () => `${BASE_API()}/api/compare/info`;

const API_CSRF_GET = () => `${BASE_API()}/api/csrf`;
const API_CONSENT = () => `${BASE_API()}/api/consent`;

const API_PROMOTERS_GET = () => `${BASE_API()}/api/promoters`;
const API_PROMOTERS_CREATE_INVITE = () => `${BASE_API()}/api/promoters`;

const API_RECAPTCHA = () => `${BASE_API()}/api/recaptcha`;

const API_COOKIES_STEPS = () => `${BASE_API()}/api/cookies/steps`;

const API_GET_FIREBASE_CONFIG = () => `${BASE_API()}/api/firebase`;

export const getFirebaseConfig = async () => {
    try {
        const res = await commonGetData(false, {}, API_GET_FIREBASE_CONFIG(), null, 180);
        return await createResFromResponse<any>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const fetchCsrf = async () => {
    try {
        const res = await getData(API_CSRF_GET())
        return await createResFromResponse<any>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const fetchMapsReview = async () => {
    try {
        const res = await getData(API_GET_MAPS_REVIEW())
        return await createResFromResponse<MapsData>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const fetchCountries = async (param: AdvisoryCountriesRequest) => {
    try {
        const res = await getData(API_GET_COUNTRIES(), {
            page: param.page,
            per_page: param.perPage,
            query_search: param.query,
            lang: param.lang
        })
        return await createResFromResponse<StudentCountriesResDTO>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const fetchCities = async (param: AdvisoryCitiesRequest) => {
    try {
        const res = await getData(API_GET_CITIES(), {
            page: param.page,
            per_page: param.perPage,
            query_search: param.query,
            lang: param.lang
        })
        return await createResFromResponse<CitiesResDTO>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const fetchSchoolCoursesWithPaginate = async (param: FetchSchoolCoursesParam) => {
    try {
        const res = await getData(API_GET_SCHOOL_COURSES(), {
            page: param.page,
            per_page: param.per_page,
            query_search: param.query_search,
            school_id: param.school_id,
            course_types: param.course_types,
        })
        return await createResFromResponse<SchoolCoursesResource>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const fetchSchoolCoursesTypologiesWithPaginate = async (param: SchoolCourseTypologiesRequest) => {
    try {
        const res = await getData(API_GET_SCHOOL_COURSES_TYPOLOGIES(), {
            page: param.page,
            perPage: param.perPage,
            schoolTypologyName: param.schoolTypologyName,
            schoolUuid: param.schoolUuid,
            schoolCourseTypologies: param.schoolCourseTypologies
        })
        return await createResFromResponse<SchoolCourseTypologySearchResDTO>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const fetchSchoolPropaedeuticDegree = async (param: SchoolPropaedeuticDegreeRequest) => {
    try {
        const res = await getData(API_GET_SCHOOL_PROPAEDEUTIC_DEGREE(), {
            courseType: param.courseType,
        })
        return await createResFromResponse<SchoolCoursesResource>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const postGenerateOpportunities = async (data: CertificationReq): Promise<Res<CertificationResp>> => {
    try {
        console.log('*** call postGenerateOpportunities... data: ', data)
        const res = await postData(API_COMPARE(), data)
        console.log('*** call postGenerateOpportunities...res: ', res)
        return await createResFromResponse<CertificationResp>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const getOpportunities = async (uuid: string, shared: boolean = false) => {
    try {
        console.log('*** call getOpportunities... data: ')
        const res = await getData(API_COMPARE(), {
            uuid: uuid,
            shared: shared,
        })
        console.log('*** call getOpportunities...res: ', res)
        return await createResFromResponse<CertificationResp>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const getCompareInfo = async () => {
    try {
        console.log('*** call getCompareInfo... data: ')
        const res = await getData(API_COMPARE_INFO())
        console.log('*** call getCompareInfo...res: ', res)
        return await createResFromResponse<ResultsExtraDataResp>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const postPreCertificationSearch = async (data: PostExecuteCertificationsDTO) => {
    try {
        console.log('*** call pre certifications search POST... data: ', data)
        const res = await postData(API_CERTIFICATIONS_SEARCH(), data)
        console.log('*** call pre certifications search POST...res: ', res)
        return await createResFromResponse<CertificationsResponse>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const performConsent = async () => {
    try {
        const res = await getData(API_CONSENT());
        return await createResFromResponse<Array<Consent>>(res);
    } catch (e) {
        console.error("get consent failed", e);
        return createExceptionRes(e);
    }
}

export const performRecaptcha = async (token: string) => {
    try {
        const res = await postData(API_RECAPTCHA(), { token });
        return await createResFromResponse<any>(res);
    } catch (e) {
        console.error("Login failed", e);
        return createExceptionRes(e);
    }
}

export const fetchSchoolsWithPaginate = async (param: FetchSchoolsParam) => {
    // mandare all'algoritmo id, nome, typologia, address
    // nel caso di scelta ente  a_mano aggiungere address (di google)
    try {
        const res = await getData(API_GET_SCHOOLS(), {
            page: param.page,
            per_page: param.per_page,
            query_search: param.query_search || '',
            school_typologies: param.school_typologies,
            course_typologies: param.course_typologies,
            uuids: param.uuids?.join(',')
        })
        return await createResFromResponse<SchoolsResource>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const createCertifications = async (
    data: CertificationsRequest
) => {
    try {

        const res = await postData(API_CREATE_CERTIFICATIONS(), data);
        return await createResFromResponse<CertificationsResponse>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const certificationsHealthCheck = async () => {
    try {
        const res = await getData(API_CERTIFICATIONS_HEALTH_CHECK());
        return await createResFromResponse<any>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const postCookiesSteps = async (step: string, embedded: boolean) => {
    try {
        const res = await postData(API_COOKIES_STEPS(), {
            step: step,
            embedded: embedded
        });
        return await createResFromResponse<any>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const getPromoters = async (code: string) => {
    try {
        const res = await getData(API_PROMOTERS_GET(), {
            code: code
        });
        return await createResFromResponse<PromoterSearchItemResource[]>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}

export const postPromoterInvite = async (data: PostPromoterInviteRequest) => {
    try {
        const res = await postData(API_PROMOTERS_CREATE_INVITE(), data);
        return await createResFromResponse<any>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
}